import React, { createContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ISerialConnection, SerialConnection } from "./connection";
import {
  IVavisSerialConnection,
  VavisSerialConnection,
} from "./serialConnection";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const serialService = new VavisSerialConnection();

export const SerialServiceContext =
  createContext<IVavisSerialConnection>(serialService);

root.render(
  <React.StrictMode>
    <SerialServiceContext.Provider value={serialService}>
      <App />
    </SerialServiceContext.Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
